import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 174 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#008583;}.cls-2{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M53.06,33.27V11.24c0-2.54,1.86-4.02,3.94-4.02,1.67,0,3,.61,3.83,2.01l10.08,17.29V7.75h5.23V29.78c0,2.54-1.86,3.98-3.87,3.98-1.63,0-3.03-.57-3.87-1.97l-10.08-17.4v18.88h-5.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M80.37,23.71c0-5.42,3.94-9.9,9.74-9.9s9.4,4.4,9.4,9.52v1.59h-13.95c.38,2.5,2.31,4.17,5.01,4.17,2.05,0,3.75-.99,4.63-2.73l4.13,2.09c-1.63,3.38-4.74,5.31-8.72,5.31-5.84,0-10.24-4.06-10.24-10.05Zm13.8-1.78c-.23-1.93-1.82-3.41-4.09-3.41s-3.91,1.52-4.28,3.41h8.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M102.32,23.82c0-5.42,4.44-9.9,10.16-9.9s10.2,4.51,10.2,9.9-4.44,9.93-10.2,9.93-10.16-4.47-10.16-9.93Zm14.98,.04c0-2.65-2.05-4.85-4.82-4.85s-4.78,2.2-4.78,4.85,2.01,4.85,4.78,4.85,4.82-2.2,4.82-4.85Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M125.3,28.37l2.05-1.02c1.1,2.5,3.6,3.91,6.86,3.91,3.49,0,6.14-1.78,6.14-4.89,0-3.37-3.03-4.02-6.37-4.7-3.83-.83-8.19-1.97-8.19-7.01,0-3.98,3.68-6.98,8.07-6.98,3.64,0,6.9,1.74,8.3,5.08l-2.01,1.06c-1.14-2.46-3.37-3.83-6.37-3.83s-5.57,1.93-5.57,4.59c0,3.34,3.11,4.02,6.45,4.74,3.83,.83,8.11,1.97,8.11,7.05,0,4.32-3.72,7.2-8.57,7.2-4.02,0-7.51-1.86-8.91-5.19Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M146.64,28.37l2.05-1.02c1.1,2.5,3.6,3.91,6.86,3.91,3.49,0,6.14-1.78,6.14-4.89,0-3.37-3.03-4.02-6.37-4.7-3.83-.83-8.19-1.97-8.19-7.01,0-3.98,3.68-6.98,8.07-6.98,3.64,0,6.9,1.74,8.3,5.08l-2.01,1.06c-1.14-2.46-3.37-3.83-6.37-3.83s-5.57,1.93-5.57,4.59c0,3.34,3.11,4.02,6.45,4.74,3.83,.83,8.11,1.97,8.11,7.05,0,4.32-3.72,7.2-8.57,7.2-4.02,0-7.51-1.86-8.91-5.19Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M172.28,7.94v25.33h-2.43V7.94h2.43Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M35.88,0s0,0,0,0H5.12C3,0,1.18,1.29,.4,3.13c-.26,.61-.4,1.29-.4,2v30.75H0v5.08H4.91c.08,0,.14,.04,.22,.04h30.75c2.83,0,5.12-2.29,5.12-5.12h0V0h-5.12Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M11.27,11.28h2.05c.57,0,1.02-.46,1.02-1.02s-.46-1.03-1.02-1.03h-2.05c-.57,0-1.03,.46-1.03,1.03s.46,1.02,1.03,1.02Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M11.27,16.4h9.22c.57,0,1.02-.46,1.02-1.03s-.46-1.02-1.02-1.02H11.27c-.57,0-1.03,.46-1.03,1.02s.46,1.03,1.03,1.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M11.28,19.47c-.57,0-1.03,.46-1.03,1.03s.46,1.02,1.03,1.02h2.05c.57,0,1.03-.46,1.03-1.02s-.46-1.03-1.03-1.03h-2.05Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M10.25,25.62c0,.57,.46,1.02,1.03,1.02h9.22c.57,0,1.02-.46,1.02-1.02s-.46-1.03-1.02-1.03H11.27c-.57,0-1.03,.46-1.03,1.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M13.32,29.72h-2.05c-.57,0-1.03,.46-1.03,1.03s.46,1.02,1.03,1.02h2.05c.57,0,1.03-.46,1.03-1.02s-.46-1.03-1.03-1.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M32.8,22.54c1.13,0,2.05-.92,2.05-2.05s-.92-2.05-2.05-2.05h-7.18v-6.14h7.18c1.13,0,2.05-.92,2.05-2.05s-.92-2.05-2.05-2.05h-7.18V4.13H6.15V36.88H25.62v-4.09h7.18c1.13,0,2.05-.92,2.05-2.05s-.92-2.05-2.05-2.05h-7.18v-6.15h7.18Zm-9.22,6.15h-5.13c-1.13,0-2.05,.92-2.05,2.05s.92,2.05,2.05,2.05h5.13v2.04H8.2V6.18h15.37v2.02h-5.13c-1.13,0-2.05,.92-2.05,2.05s.92,2.05,2.05,2.05h5.13v6.14h-5.13c-1.13,0-2.05,.92-2.05,2.05s.92,2.05,2.05,2.05h5.13v6.15Z"
			})
		] })] })
	]
});
export default SvgLogo;
